<div class="">
    <div class="">
        <div>
            <div class="maintextContainer">
                <h1>Filter</h1>
                <i class="fa fa-times closebtn" aria-hidden="true" [mat-dialog-close]="true"></i>
            </div>
            <div class="col-md-12">
                <div>
                    <form [formGroup]="counsellingReport">
                        <!-- <div class="row mt-3"> -->
                        <div class="col-sm-12  mb-3 mt-3">
                            <mat-label class="font-size custom-label" >Academic Year </mat-label>
                            <mat-select class="form-control" placeholder="Select Academic year"
                                formControlName="Academic" (selectionChange)="onAcademicYearChange($event.value)">
                                <input matInput [matAutocomplete]="classauto" formControlName="Academic12"
                                    class="intbtn" placeholder="select Academic year">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let class of AcademicOptions | async" (click)="getCampus1()"
                                    (click)="clearCampus()" [value]="class?.year">
                                    {{class.year}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class="font-size custom-label">State </mat-label>
                            <mat-select class="form-control" placeholder="Select State" formControlName="StateControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="StateControl2"
                                    class="intbtn" placeholder="Select State">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let class of stateOptions | async" (click)="getCity(class)"
                                        (click)="clearCity()" [value]="class?.stateId">
                                        {{class.stateName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class=" font-size custom-label" >City </mat-label>
                            <mat-select class="form-control" placeholder="Select City" formControlName="cityControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="cityControl12"
                                    class="intbtn" placeholder="select City">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                               
                                <mat-option *ngFor="let class of cityOptions | async" (click)="getCampus(class)"
                                        (click)="clearCampus()" [value]="class?.cityId">
                                        {{class.cityName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <mat-label class="font-size custom-label">Campus </mat-label>
                            <mat-select class="form-control" placeholder="Select Campus"
                                formControlName="campusControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="CampusControl2"
                                    class="intbtn" placeholder="select Campus">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let class of campusOptions | async" (click)="getCounseller(class)"
                                        (click)="clearCounsler()" [value]="class?.campusId">
                                        {{class.campusName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class="font-size custom-label" >Counseller Name </mat-label>
                            <mat-select class="form-control" placeholder="Select Counseller Name"
                                formControlName="CounsellerControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="CounsellerControl12"
                                    class="intbtn" placeholder="Counseller Name">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                              
                                <mat-option *ngFor="let class of counserlistOptions | async" (click)="getReasonss(class)"
                                       [value]="class?.empId"    (click)="clearReason()">
                                        {{class.empName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <mat-label class="font-size custom-label" >Referral&Reasons </mat-label>
                            <mat-select class="form-control" placeholder="Select Referral & Reasons"
                                formControlName="ReasonsControl" >
                                <input matInput [matAutocomplete]="classauto" formControlName="ReasonsControl2"
                                    class="intbtn" placeholder="Select Referral & Reasons">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                               
                                <mat-option *ngFor="let class of ReasonsOptions | async" (click)="getIssues(class)"
                                        (click)="clearIdentification()" [value]="class?.counselCatId">
                                        {{class.type}}</mat-option>
                            </mat-select>
                        </div>
                 
                        <div class="col-sm-12 mb-3  ">
                            <mat-label class="font-size mb-2 custom-label" >Issues Identified </mat-label>
                            <mat-select class="form-control" placeholder="Select Issues Identified"
                                formControlName="IdentifiedControl"   multiple>
                                <input matInput [matAutocomplete]="classauto" formControlName="IdentifiedControl2"
                                    class="intbtn" placeholder="Select Issues Identified">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                              
                                <mat-option *ngFor="let class of IdentifiedOptions | async" 
                                     [value]="class?.counselCatRsnId">
                                        {{class.reasonName}}</mat-option>
                            </mat-select>
                        </div>  
                    </form>
                    <div class="col-lg-12 text-center mt-3">
                        <button type="button" class="applybtn" (click)="getReport()">Get Report</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>